export default __webpack_public_path__ + "static/688-4d0b050891fa11751e669f401025d1d0.gif";